import type { AdminEpisodeSummary, EpisodePlan, RefineShotRequest, RefineShotResponse } from "@storyline/shared";
import { unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";

export const requestEpisodeProposal = async (seriesId: string, brief: string): Promise<EpisodePlan> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).episodes.proposal.post({ brief })));

export const commitEpisodePlan = async (seriesId: string, plan: EpisodePlan): Promise<AdminEpisodeSummary> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).episodes.commit.post({ plan })));

export const refineShot = async (body: RefineShotRequest): Promise<RefineShotResponse> =>
	unwrap(await request(() => httpClient.admin.copilot["refine-shot"].post(body)));
